import { Component, OnInit, OnDestroy } from '@angular/core';
import { SignUpContentServiceService } from '../../services/sign-up-content-service.service';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-image-link-list',
    templateUrl: './image-link-list.component.html',
    styleUrls: ['./image-link-list.component.scss']
})
export class ImageLinkListComponent implements OnInit, OnDestroy {
  content:any;
  dictionaryContent: any;
  private destroy$ = new Subject<void>();

  constructor(
    private readonly registerContent:SignUpContentServiceService,
    private readonly dictionaryContentService: DisctionaryContent
  ){

  }
  ngOnInit(){
    this.registerContent.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.content = res;
    });

    this.dictionaryContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.dictionaryContent = res;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}